import { combineReducers } from 'redux';
import User from './User';
import Inspection from "./Inspection";
import carpetBasicReport from './carpetBasicReport';
import hardwoodDetailedReport from './hardwoodDetailedReport';
import laminateReport from './laminateReport';
import tileReport from './tileReport';
import lvtReport from './lvtReport';
import carpetDetailReport from './carpetDetailReport';
import hardSurfaceBasicReport from './hardSurfaceBasicReport';
import quickReport from './quickReport';
import nwfaInstallationReport from './nwfaInstallationReport';
import nwfaSandFinishReport from './nwfaSandFinishReport';
import mohawkFieldServiceReport from './mohawkFieldServiceReport';
import analyticsReducer from './analytics';

const RootReducer = combineReducers({ 
  User, 
  Inspection, 
  carpetBasicReport, 
  hardwoodDetailedReport, 
  laminateReport, 
  tileReport, 
  lvtReport,
  carpetDetailReport,
  hardSurfaceBasicReport,
  quickReport,
  nwfaInstallationReport,
  nwfaSandFinishReport,
  mohawkFieldServiceReport,
  analytics: analyticsReducer,
});
export default RootReducer;
